import React from 'react'

import { City as CoreCity, Util } from '@grandvision/forms'
import { useIntl } from '@grandvision/state'

const { isText, maxLength, minLength } = Util.validations

export const City = ({ required = true }) => {
  const { getLabel } = useIntl()

  return (
    <CoreCity
      label={getLabel('checkout.address.city')}
      errorMessage={getLabel('checkout.address.city.errorMessage')}
      validations={[minLength(2), maxLength(50), isText]}
      required={required}
    />
  )
}
